<app-create-asin-header></app-create-asin-header>

<div class="land-bg" style="{{minHeight}}">

    <div class="container mb-4" style="{{minHeight2}}">
        <div style="padding: 50px 30px;">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="question-card">
                        <p>Verify Account With?</p>
                        <div class="d-flex flex-row align-items-center">
                            <div class="d-flex flex-row align-items-center me-4">
                                <label class="me-2">Email</label>
                                <input type="radio" />
                            </div>
                            <div class="d-flex flex-row align-items-center">
                                <label class="me-2">SMS</label>
                                <input type="radio" />
                            </div>
                        </div>
                        <br />
                        <div class="d-flex flex-column">
                            <input placeholder="Enter your email address" class="mb-3" />
                            <button routerLink="/create-asin/verification-code">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>

</div>

